<div class="container-fluid p-4 d-flex flex-column gap-4">
  <div class="row">
    <div class="col">
      @if (customerCardEnabled) {
      <groundworks-card [title]="'Customer'" [action]="{ label: 'Deselect', click: onDeselect }">
        <groundworks-card-body>
          <app-customer-opportunities-card
            [customerOpportunities]="customerOpportunities()"
            [isLoadingInput]="opportunityLoading() || customerOpportunitiesLoading()"
            [hasErrorInput]="opportunityError() || customerOpportunitiesError()"
          />
        </groundworks-card-body>
      </groundworks-card>
      } @else {
      <app-selected-opportunity
        [opportunity]="opportunity()"
        [isLoadingInput]="opportunityLoading()"
        [hasErrorInput]="opportunityError()"
      />
      }
    </div>
  </div>

  <div class="row">
    <div class="col">
      <app-pending-sale-activity
        [variant]="isPendingSale() ? 'actions' : 'overview'"
        [isPendingSale]="isPendingSale()"
        [appointments]="appointments()"
        [quote]="activeQuote()"
        [opportunityId]="opportunityId()"
        [canSaleBeApproved]="opportunity()?.canSaleBeApproved ?? false"
        [isLoadingInput]="opportunityLoading()"
        [hasErrorInput]="opportunityError()"
        (quoteCompletedItemsChange)="onQuoteCompletedItemsChange($event)"
        (saleCreated)="onSaleCreated($event)"
        (appointmentCreated)="onAppointmentCreated($event)"
        (removeFromFollowUp)="onRemoveFromFollowUp($event)"
        (dispositionUpdated)="onDispositionUpdated()"
      />
    </div>
  </div>

  <div class="grid columns-12">
    <div class="g-col-9 h-100">
      @switch (getQuotesState()) { @case ('loading') {
      <groundworks-card>
        <groundworks-card-body>
          <groundworks-state-message
            type="loading"
            message="Loading Quotes..."
            class="d-flex mt-5"
          />
        </groundworks-card-body>
      </groundworks-card>
      } @case ('no-matches') {
      <groundworks-card>
        <groundworks-card-body>
          <groundworks-state-message
            type="no-matches"
            message="No Quotes Found."
            class="d-flex mt-5"
          />
        </groundworks-card-body>
      </groundworks-card>
      } @case ('error') {
      <groundworks-card>
        <groundworks-card-body>
          <groundworks-state-message
            type="error"
            message="Error loading Quotes."
            class="d-flex mt-5"
          />
        </groundworks-card-body>
      </groundworks-card>
      } @case ('matches') { @for (quote of quotes(); track quote.id; let i = $index) {
      <app-quote-viewer [quote]="quote" [initiallyExpanded]="i === 0" />
      } } }
    </div>
    <div class="g-col-3 align-self-stretch d-flex flex-column gap-4">
      @if (paymentsEnabled) {
      <app-payments [opportunityId]="opportunityId()!" [customerId]="opportunity()?.customerId" />
      }
      <app-sales-touchpoints
        class="h-100"
        [touchPointsInput]="touchPoints()"
        [isLoadingInput]="touchPointsLoading()"
        [hasErrorInput]="touchPointsError()"
        [opportunityId]="opportunityId()!"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <app-attachments
        [attachments]="attachments()"
        [quoteInfo]="quotes()"
        [isLoading]="attachmentsLoading()"
        [hasError]="attachmentsError()"
        [opportunityId]="opportunityId()"
        [appointmentId]="firstAppointment()?.id ?? null"
        (attachmentDeleted)="onAttachmentDeleted($event)"
        (attachmentAdded)="onAttachmentAdded()"
        (attachmentUpdated)="onAttachmentUpdated($event)"
      />
    </div>
  </div>
</div>
